import React from "react";
import PrintLayout from "./PrintLayout";

export default function InsurancePrint({ data }) {
  const user = data.userId || {};

  return (
    <PrintLayout>
      <h4>Customer Details</h4>
      <p><b>Name:</b> {user.name}</p>
      <p><b>Account Number:</b> {user.accountNumber}</p>

      <h4 className="mt-3">Insurance Details</h4>
      <p><b>Policy Number:</b> {data.policyNumber}</p>
      <p><b>Provider:</b> {data.provider}</p>
      <p><b>Type:</b> {data.type}</p>
      <p><b>Premium:</b> ₹ {data.premiumAmount}</p>
      <p><b>Coverage:</b> ₹ {data.coverageAmount}</p>
      <p><b>Start Date:</b> {new Date(data.startDate).toLocaleDateString()}</p>
      <p><b>End Date:</b> {new Date(data.endDate).toLocaleDateString()}</p>
    </PrintLayout>
  );
}
